import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getUser } from "constants/apiUrls";
const userApi = createApi({
  reducerPath: "user",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  endpoints: (builder) => ({
    user: builder.query<Array<EntityType>, { token?: string; uuid: string }>({
      query: (arg) => {
        const { token, uuid } = arg;
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            token || JSON.parse(localStorage.getItem("token") || "")
          }`,
        };
        return {
          url: getUser(uuid),
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useUserQuery, useLazyUserQuery } = userApi;
export default userApi;
